import React, { useEffect, useState } from 'react';
import AddSalesRegister from './AddSalesRegister';
import { fetchSalesRegisterById } from '../../utils/salesRegisterApi';
import { getStorageValues } from '../../shared/CommonFunctions';

function EditSalesRegister({ selectedRow, sendDataToParent, onLoanSummary, onRegisterLoanSummaryApply }) {
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(null);
  const salesRegisterId = selectedRow?.SalesRegisterId;

  useEffect(() => {
    const load = async () => {
      if (!salesRegisterId) {
        setInitialValues(null);
        return;
      }
      setLoading(true);
      try {
        const result = await fetchSalesRegisterById({
          salesRegisterId
        });

        const header = result?.header || {};
        const details = result?.details || [];
        
        // Format SalesDate to YYYY-MM-DD for date input
        let formattedSalesDate = '';
        if (header.SalesDate) {
          const dateObj = new Date(header.SalesDate);
          if (!isNaN(dateObj.getTime())) {
            const year = dateObj.getFullYear();
            const month = String(dateObj.getMonth() + 1).padStart(2, '0');
            const day = String(dateObj.getDate()).padStart(2, '0');
            formattedSalesDate = `${year}-${month}-${day}`;
          }
        }
        
        const mappedSalesRegisterDetails = details.map((d) => ({
          id: d.SalesRegisterDetailId || d.id,
          SalesRegisterDetailId: d.SalesRegisterDetailId,
          VehicleId: d.VehicleId,
          VehicleLabel: d.VehicleLabel || d.Vehicle || d.VehicleNameValue || '',
          VehicleCost: d.VehicleCost,
          PaymentType: d.PaymentType,
          PaymentTypeLabel: d.PaymentType,
          DownPayment: d.DownPayment,
          EMITenure: d.EMITenure,
          EMIAmount: d.EMIAmount,
          ProcessingFees: d.ProcessingFees,
          InterestRate: d.InterestRate || '',
          ChassisNo: d.ChassisNo || '',
          EngineNo: d.EngineNo || '',
          PaymentTypeValue: d.PaymentType,
          VehicleNameValue: d.VehicleLabel || d.Vehicle || '',
          Selected: true
        }));

        const payload = {
          SalesRegisterId: salesRegisterId,
          EnquiryId: header.EnquiryId || null,
          CustomerName: header.CustomerName || '',
          MobileNumber: header.MobileNumber || '',
          EmailId: header.EmailId || '',
          SalesDate: formattedSalesDate,
          Remarks: header.Remarks || '',
          SalesRegisterDetails: mappedSalesRegisterDetails
        };

        setInitialValues(payload);
        sendDataToParent(payload);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [salesRegisterId]);

  if (loading && !initialValues) {
    return <div className="p-2">Loading...</div>;
  }

  return (
    <AddSalesRegister
      sendDataToParent={sendDataToParent}
      onLoad={() => {}}
      initialValues={initialValues}
      onLoanSummary={onLoanSummary}
      onRegisterLoanSummaryApply={onRegisterLoanSummaryApply}
    />
  );
}

export default EditSalesRegister;